import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import { templatePriorities } from 'reducers/templates/selectors';
import { theme } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';

const mapStateToProps = combineSelectors({
  templatePriorities,
  theme,
});

export const priorities = () => ['2', '3', '4', '5'];

export const textStyle = ({ theme }) => ({ color: theme.dropDownText });

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['expandPrioritiesLabel', 'collapsePrioritiesLabel'],
  }),
  connect(mapStateToProps),
  flattenProp('templatePriorities'),
  addProps({ priorities, textStyle }),
);
